import React, { Component, useState, useContext } from 'react'

import { Document, Page, View, StyleSheet, Image } from '@react-pdf/renderer'
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer'
import html2canvas from 'html2canvas'
import {
  Box,
  Grid,
  Heading,
  Text,
  Image as GrommetImage,
  Main,
  Anchor,
  Button,
  Tip,
  Layer
} from 'grommet'
import { DonationMetricsSmall,DonationMetricsSmallLM, MetricsBoxPoster } from './Donations'
import { getDepartmentForIdV2, opsAPI } from '../api/retail'

import {
  calculateImpactMetrics,
  calculateImpactMetricsSP,
  getTotalByKeyFromResults,
  getTotalWeightFromResults,
  labelByMode
} from '../libs/common'
import { LogoWithTagLine } from '../Image'
import withOpsApi from './withOpsApi'
import {
  CircleQuestion,
  CloudDownload,
  DocumentDownload,
  Download,
  Group,
  Mail,
  MailOption,
  ShareRounded
} from 'grommet-icons'
import firebase from '../libs/firebase'
import FSM_Logo from '../images/FSM_logo.png'
import IGA_Logo from '../images/IGA_logo.png'
import SOF_Logo from '../images/SOF_logo.png'
import NFM_Logo from '../images/NFM_logo.png'
import BLF_Logo from '../images/BLF_logo.png'
import CHM_Logo from '../images/CHM_logo.png'
import URF_Logo from '../images/URF_logo.png'
import MFF_Logo from '../images/MFF_logo.png'
import PRS_Logo from '../images/PRS_logo.png'
import QTF_Logo from '../images/QTF_logo.png'
import MGS_Logo from '../images/MGS_logo.png'
import { PageHeader, RoundIconButton } from './Common'
import { SelectMonthInYear } from './Select'
import { setLongDateRange } from '../libs/date'
import moment from 'moment'
import { CharityOrganization } from '../MeshIcon'
import { AppContext } from '../libs/context'
import { OpsResultsTable } from './Data'
import { PageCard } from './Cards'
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF'
  },
  section: {
    margin: 10,
    // padding: 10,
    flexGrow: 1
  }
})
/**
 * Passed down to be rendered by OpsResultsTable so that it can recieve api props and pass then
 * to a custom on click function
 * @param filtersToPassThrough {Object} passed down from withOpsApi higher order component
 * @returns {JSX.Element}
 * @constructor
 */
const MailerFilterApiButton = ({ onClick, label, disabled, filtersToPassThrough }) => (
  <Button
    color="light-4"
    onClick={() => onClick(filtersToPassThrough)}
    label={label}
    disabled={disabled}
  />
)
export const MailableContactList = (props) => {
  const { actions, companies, receivers, demoMode } = useContext(AppContext)
  const [submitting, setSubmitting] = useState(false)
  const [confirmData, setConfirmData] = useState(undefined)

  const triggerMailer = (data, callback) => {
    const response = opsAPI.postToRetail('reports/charity_poster_contacts/', data)
    setSubmitting(true)

    response
      .then((response) => {
        setSubmitting(false)
        const mailers = response.data.result.mailers
        actions.showAsToast({
          title: 'Queued',
          message: Object.keys(mailers)
            .map((key) => mailers[key])
            .toString(),
          type: 'success'
        })
        callback && callback()
      })
      .catch((e) => {
        setSubmitting(false)
        callback && callback()
        actions.showResponseAsError(e)
      })
  }
  return (
    <>
      <OpsResultsTable
        heading={labelByMode('mailable', demoMode)}
        {...props}
        apiPath={'retail/reports/charity_poster_contacts/'}
        apiParams={{ with_company_id: 0, with_receiver_id: 0 }}
        apiFilters={[
          // {
          //   label: 'Store Posters',
          //   field: 'store_posters',
          //   // defaultValue: false,
          //   useCheckBoxValue: true
          // },
          {
            label: 'For Company',
            field: 'with_company_id',
            optionProps: { valueKey: 'id', labelKey: 'name' },
            defaultValue: 0,
            options: [{ id: 0, name: 'All' }, ...Object.values(companies)]
          },
          // {
          //   label: 'Charity Reports',
          //   field: 'charity_reports',
          //   // defaultValue: true,
          //   useCheckBoxValue: true
          // },

          {
            label: 'For Receiver',
            field: 'with_receiver_id',
            optionProps: { valueKey: 'id', labelKey: 'name' },
            defaultValue: 0,
            options: [{ id: 0, name: 'All' }, ...Object.values(receivers)]
          }
        ]}
        manyFilterActionButtonProps={[
          {
            RenderComponent: MailerFilterApiButton,
            disabled: submitting,
            label: submitting ? 'Sendng..' : 'Send',
            onClick: setConfirmData
          }
        ]}
        // headerItems={
        //   <Button
        //     disabled={submitting}
        //     label={submitting ? 'Sendng..' : 'Send'}
        //     onClick={triggerMailer}
        //   />
        // }
        renderResultWith={
          {
            //   ResultComponent: BulkScan,
            //   recordType: 'receiver',
            //   apiParams: { expand: ['store_set'] }
          }
        }
        showColumns={[
          {
            property: 'email',
            header: <Text weight={'bold'}>E-mail</Text>,
            primary: true,
            search: true
          },
          {
            property: 'first_name',
            search: true
          },
          {
            property: 'report_type',
            search: true
          },
          {
            property: 'organization_name',
            search: true
          },
          {
            property: 'report_url',
            render: ({ report_url }) => (
              <RoundIconButton
                disabled={submitting}
                background={'white'}
                Icon={ShareRounded}
                href={report_url}
              />
            )
          }
        ]}
      />
      {confirmData && (
        <Layer
          background={'none'}
          onEsc={() => setConfirmData(null)}
          onClickOutside={() => setConfirmData(null)}
        >
          <PageCard
            // width={'medium'}
            background={'white'}
            show={confirmData}
            round={'small'}
            elevation={'xlarge'}
            heading={'Confirm sending mail'}
            closeAction={() => setConfirmData(null)}
          >
            <Box pad={'large'} fill align={'center'} justify={'center'} gap={'small'}>
              <Box pad={{ bottom: 'medium' }}>
                <MailOption size={'xlarge'} color={'light-6'} />
              </Box>
              <Text size={'large'}>Are you sure? This cannot be undone!</Text>
              <Button
                disabled={submitting}
                label={'Confirm'}
                primary
                color={'status-critical'}
                onClick={() => triggerMailer(confirmData, () => setConfirmData(null))}
              />
            </Box>
          </PageCard>
        </Layer>
      )}
    </>
  )
}
// Create Document Component
class MyDocument extends Component {
  state = { data: null }
  componentDidMount() {
    let imgData = null
    const { height, width } = this.props
    // const [width, height] = [595.28 * 2, 841.89 * 2]

    const input = document.getElementById('toPDF')
    html2canvas(input, {
      width: width,
      height: height,
      windowWidth: width,
      windowHeight: height * 1.12,
      scale: 8
    }).then((canvas) => {
      this.setState({ data: canvas.toDataURL('image/png') })
    })
  }

  render() {
    return (
      <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>
          <View style={styles.section}>
            <Image src={this.state.data} />
          </View>
        </Page>
      </Document>
    )
  }
}
export const StorePosterPage = ({ apiPath, apiParams = {} }) => {
  const [dateParams, setParams] = useState(setLongDateRange(moment().subtract(1, 'month').toDate()))
  const setDateRange = (date) => {
    setParams(setLongDateRange(date))
  }
  const [stateLM, setstateLM] = useState([]);
  return (
    <Box fill background={'light-3'} align={'center'}>
      <PageHeader
        fill={'horizontal'}
        pad="medium"
        direction={'row-responsive'}
        heading={'Store Poster'}
      >
        <Box flex={'grow'} />

        <SelectMonthInYear
          // disabled={loadingChildren}

          endDate={new Date()}
          selectAction={({ year, month }) => setDateRange(new Date(year, month, 15))}
        />
      </PageHeader>
      <Main>
      <StorePosterLM
          apiPath={apiPath}
          apiParams={{
            ...apiParams,
            ...{
              annotate: ['destination_id', 'receiver_id'],
              entry_time__gte: dateParams.monthStartDate.toISOString(),
              entry_time__lte: dateParams.monthEndDate.toISOString() // cumulative only
            }
          }}
          stateLM={stateLM}
          setstateLM={setstateLM}
        />
        <StorePoster
          apiPath={apiPath}
          apiParams={{
            ...apiParams,
            ...{
              annotate: ['destination_id', 'receiver_id'],
              // entry_time__gte: dateParams.monthStartDate.toISOString(),
              entry_time__lte: dateParams.monthEndDate.toISOString() // cumulative only
            }
          }}
          stateLM={stateLM}
        />
        <Box margin="large" pad={'large'} flex={false} />
      </Main>
    </Box>
  )
}

class _StorePosterLM extends Component {
  static defaultProps = {
    fromApi: { results: [], apiParams: {} },
    apiActions: {}
  }
componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.fromApi.results !== this.props.fromApi.results) {
      this.getMetrics()
    }
  }
  componentDidMount() {
    firebase.analytics().logEvent('page_view', {
      // page_location: url,
      // page_path: path,
      page_title: 'Store Poster'
    })
    this.getMetrics()
  }
  getMetrics = () => {
    const { setstateLM } = this.props;
    //this.setState({ metricsLoadingLM: true })

    const apiValues = getTotalByKeyFromResults(this.props.fromApi.results, [
      'meals_provided__sum',
      'money_saved__sum',
      'food_rescued_kg__sum',
      'co2_emissions_kg__sum'
    ])
    const metricsObj = calculateImpactMetricsSP(
      0,
      0,
      {
        showMoneySaved: false
      },
      apiValues
    )
    const stateLMValue = metricsObj
    setstateLM(stateLMValue)
    //this.setState({ impactMetricsLM: metricsObj, metricsLoadingLM: false })
  }
  render() { 
    return(null)
  }
}

export const StorePosterLM = withOpsApi(_StorePosterLM)

class _StorePoster extends Component {
  static defaultProps = {
    fromApi: { results: [], apiParams: {} },
    apiActions: {}
  }
  // some store brands had agreed to a custom branded poster
  brandingProfile = {
    FSM: { src: FSM_Logo, color1: '#342b2a', color2: '#007bff' },
    IGA: { src: IGA_Logo, color1: '#333', color2: 'rgb(224, 7, 38)' },
    SOF: { src: SOF_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    NFM: { src: NFM_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    BLF: { src: BLF_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    CHM: { src: CHM_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    URF: { src: URF_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    MFF: { src: MFF_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    PRS: { src: PRS_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    QTF: { src: QTF_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    MGS: { src: MGS_Logo, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    SFW: { src: undefined, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    THF: { src: undefined, color1: 'mesh-green-1', color2: 'mesh-green-2' },
    undefined: { src: undefined, color1: 'mesh-green-1', color2: 'mesh-green-2' }
  }
  state = {
    results: [],
    impactMetrics: [],
    heading: '',
    metricsLoading: false,
    storeLoading: false,
    brand: undefined,
    receiversCount: 0,
    startDate:'',
    farmersOnly: false
  }
  // Safeway and Thrifty stores donate to farmers only, so meals provided is not shown
  isFarmersOnlyStore = (name = '') => ['SFW', 'THF'].includes(name.substring(0, 3))
  getBrand = (heading) => {
    let brand = {}
    const regex = /\d+ (.+)$/
    if (heading.startsWith('FSM')) {
      brand = { brand: 'FSM',sname: 'Fresh St. Market ' +heading.match(regex)[1] }
    }
    if (heading.startsWith('IGA')) {
      brand = { brand: 'IGA',sname: 'IGA '+heading.match(regex)[1] }
    }
    if (heading.startsWith('SOF') && !heading.includes('Urban Fare') && !heading.includes('PriceSmart')) {
      brand = { brand: 'SOF',sname: 'Save-On-Foods '+heading.match(regex)[1] }
    }
    if (heading.startsWith('BLF') && heading.includes('Nesters')) {
      brand = { brand: 'NFM',sname: heading.match(regex)[1] }
    }
    if (heading.startsWith('BLF') && !heading.includes('Meinhardt') && !heading.includes('Nesters')) {
      brand = { brand: 'BLF',sname: 'Buy-Low Foods '+heading.match(regex)[1] }
    }
    if (heading.startsWith('CHM')) {
      brand = { brand: 'CHM',sname: heading.match(regex)[1]  }
    }
    if (heading.startsWith('SOF') && heading.includes('Urban Fare')) {
      brand = { brand: 'URF',sname: heading.match(regex)[1] }
    }
    if (heading.startsWith('SOF') && heading.includes('PriceSmart')) {
      brand = { brand: 'PRS',sname: heading.match(regex)[1]  }
    }
    if (heading.startsWith('BLF') && heading.includes('Meinhardt')) {
      brand = { brand: 'MFF',sname: heading.match(regex)[1] }
    }
    if (heading.startsWith('QTF')) {
      brand = { brand: 'QTF',sname: heading.match(regex)[1] }
    }
    if (heading.startsWith('MGS')) {
      brand = { brand: 'MGS',sname: heading.match(regex)[1] }
    }
    if (heading.startsWith('SFW')) {
      brand = { brand: 'SFW',sname: heading.match(regex)[1] }
    }
    if (heading.startsWith('THF')) {
      brand = { brand: 'THF',sname: heading.match(regex)[1] }
    }
    return brand
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.fromApi.results !== this.props.fromApi.results) {
      this.getMetrics()
    }
  }
  componentDidMount() {
    firebase.analytics().logEvent('page_view', {
      // page_location: url,
      // page_path: path,
      page_title: 'Store Poster'
    })
    this.getStoreInfo()
    this.getMetrics()
  }
  getStoreInfo = () => {
    const { apiParams = {} } = this.props.fromApi
    if (apiParams.from_store_id) {
      this.setState({ storeLoading: true })
    
      const url = 'reports/stores/' + apiParams.from_store_id

      const response = opsAPI.getFromRetail(url, {}, apiParams._options)
      response
        .then((result) => {
          this.setState({
            heading: this.getBrand(result.data.name).sname ? this.getBrand(result.data.name).sname : result.data.name,
            storeLoading: false,
            receiversCount:
              result.data.receivers__count + result.data.receivers__nr_supported_charities__sum,
            startDate: result.data.start_date,
            farmersOnly: this.isFarmersOnlyStore(result.data.name),
            ...this.getBrand(result.data.name)
          })
        })
        .catch((err) => this.setState({ storeLoading: false }))
    }
  }
  getMetrics = () => {
    this.setState({ metricsLoading: true })

    const apiValues = getTotalByKeyFromResults(this.props.fromApi.results, [
      'meals_provided__sum',
      'money_saved__sum',
      'food_rescued_kg__sum',
      'co2_emissions_kg__sum'
    ])
    const metricsObj = calculateImpactMetricsSP(
      0,
      0,
      {
        showMoneySaved: false
      },
      apiValues
    )
    this.setState({ impactMetrics: metricsObj, metricsLoading: false })
  }  
  render() {
    const { loading, impactMetrics, storeLoading, heading, brand, receiversCount, startDate, farmersOnly } = this.state
    const impactMetricsLM = this.props.stateLM
    const [height, width] = [655.35, 926.85]
    const { apiParams = {} } = this.props.fromApi
    const dateString = apiParams.entry_time__lte
      ? moment(apiParams.entry_time__lte).format('MMM Do YYYY')
      : ''
    const start_date = startDate
    ? moment(startDate).format('MMM YYYY')
    : ''
    const dateStringLM = apiParams.entry_time__lte
    ? moment(apiParams.entry_time__lte).format('MMM YYYY')
    : ''
    const mergeVariables = (iM, iMLMs) => {
      // if (iMLMs.length === 0) {
      //   return { ...item, valueLM: 0, unitLM:"" }
      // }
      const updatedVar = iM.map((item) => {
        const iMLM = iMLMs.find((iMLM) => iMLM.id === item.id)
        if (iMLM)  {
          return { ...item, valueLM: iMLM.value, unitLM:iMLM.unit, start_date:start_date, start_dateLM:dateStringLM }
        }
        return { ...item, valueLM: 0, unitLM:"", start_date:"", start_dateLM:"" }
      })
    
      const impactMetricsCombined = updatedVar;
      return impactMetricsCombined;
    };
    const impactMetricsCombined = mergeVariables(impactMetrics, impactMetricsLM).filter(
      (item) => !(farmersOnly && item.id === 'meals')
    )
    const receiversLabel = farmersOnly
      ? receiversCount === 1
        ? 'farmer in our community'
        : 'farmers in our community'
      : receiversCount === 1
      ? 'charity and/or farmer in our community'
      : 'charities and/or farmers in our community'
    const isSobeys = brand === 'SFW'
    return (
      <Box id={1} flex={false} align={'center'}>
        <Box
          responsive={false}
          id={'toPDF'}
          width={width + 'px'}
          height={height + 'px'}
          background={'white'}
          align={'center'}
          overflow={'hidden'}
        >
          <Box
            id={3}
            flex={false}
            fill={'horizontal'}
            //background={this.brandingProfile[brand].color2}
            background={'white'}
            height={'tiny'}
          />
          <Box id={4} flex={'grow'} align={'center'} justify={'center'}>
            <Text 
              style={{ fontFamily: 'Montserrat, sans-serif'}} 
              weight="normal" 
              size="28px" 
              color={'mesh-green-1'}
            >
              {heading} {isSobeys ? 'participates in a' : 'is a'}
            </Text>
            <Heading 
              style={{ fontFamily: 'Montserrat, sans-serif', height:'medium', margin: '5px 0', whiteSpace: 'nowrap' }}
              fill
              weight="bold"
              size="28px" 
              color={'mesh-green-1'}
            >
              {isSobeys ? 'INEDIBLE FOOD DIVERSION PROGRAM' : 'FOOD RESCUE HERO'}
            </Heading>
            <Text 
              style={{ fontFamily: 'Arvo, sans-serif', margin: '5px 0' }} 
              weight="normal"  
              size={'20px'} 
              color={'mesh-green-2'}
            >
              {isSobeys ? 'this store supports' : 'for donating its unsold food to'}
            </Text>
            <Text 
              style={{ fontFamily: 'Arvo, sans-serif'}} 
              weight="bold" 
              size={'20px'} 
              color={'mesh-green-2'}
            >
            {receiversCount} {receiversLabel}
            </Text>
          </Box>
          <Box id={5} flex={false} align={'center'} justify={'center'}>
            <DonationMetricsSmallLM
              loading={loading}
              fill
              metrics={impactMetricsCombined}
              itemProps={{
                RenderComponent: MetricsBoxPoster,
                //background: this.brandingProfile[brand].color2
                backgroud:'mesh-green-1',
                // widen the remaining tiles to take up the space left by meals provided
                tileWidth: farmersOnly ? '267px' : '170px'
              }}
              // timestamp={impactMetricsTimestamp}
              // direction={'row'}
              metricWidth={'20%'}
              // match the grid to the metric count so the remaining columns stay centred
              columns={farmersOnly ? ['125px', 'auto', 'auto'] : ['125px', 'auto', 'auto', 'auto']}
              elevation={'none'}
            >
            </DonationMetricsSmallLM>
          </Box>
            {/* <Box fill={'horizontal'} background={'mesh-yellow-1'} height={'4px'} /> */}
          {/*<Box align="between" direction={'row'}>*/}
          <Grid
            pad={{ horizontal: 'large', vertical: 'none' }}
            align={'end'}
            justify={'center'}
            fill={'horizontal'}
            columns={['small', 'flex', 'small']}
            rows={'xsmall'}
            gap="small"
          >
            <Box fill align={'start'} justify={'end'}>
              {brand && this.brandingProfile[brand].src && (
                <GrommetImage fit={'contain'} src={this.brandingProfile[brand].src} />
              )}
            </Box>
            <Box>
            <Text></Text>
            {/* <Text color={'mesh-green-2'}>*Impact in {dateStringLM}</Text> */}
            {/* <Text style={{ marginLeft: '5px' }}> donations as of {dateString}</Text> */}
            {/* <Text color={'mesh-green-1'}>*Impact since {start_date}</Text>  */}
            </Box>

            <Box fill align={'end'} justify={'end'}>
              <LogoWithTagLine />
            </Box>
          </Grid>

          {/*</Box>*/}
          <Box
            flex={false}
            fill={'horizontal'}
            background={'white'}
            height={'tiny'}
          />
        </Box>
        {impactMetrics.length > 0 && heading.length > 0 && !storeLoading && (
          <Box pad="medium" flex={false} height="xsmall" width={'small'} round={'xxsmall'}>
            <PDFDownloadLink
              document={<MyDocument width={width} height={height} />}
              fileName={'poster_' + apiParams.entry_time__lte + '.pdf'}
            >
              {({ blob, url, loading, error }) => (
                <Button
                  download={'poster_' + apiParams.entry_time__lte + '.pdf'}
                  size={'large'}
                  primary
                  reverse
                  disabled={loading || error}
                  icon={<CloudDownload />}
                  label={loading ? 'Generating PDF...' : 'Download'}
                  href={url}
                />
              )}
            </PDFDownloadLink>
          </Box>
        )}
      </Box>
    )
  }
}
export const StorePoster = withOpsApi(_StorePoster)
export const ExampleDocPdf = () => (
  <Box flex={'grow'}>
    <StorePoster
      apiPath={'retail/network/donation_totals'}
      apiParams={{ page_size: 9999, annotate_metrics: true }}
    />
    {/*<Box id={'toPDF'} width={'large'} height={'large'} />*/}

    {/*<PDFViewer>*/}
    {/*  <MyDocument />*/}
    {/*</PDFViewer>*/}
  </Box>
)
